import { render, staticRenderFns } from "./goodsFillAdd.vue?vue&type=template&id=1621e479&scoped=true&"
import script from "./goodsFillAdd.vue?vue&type=script&lang=js&"
export * from "./goodsFillAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodsFillAdd.vue?vue&type=style&index=0&id=1621e479&scoped=true&lang=scss&"
import style1 from "./goodsFillAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621e479",
  null
  
)

export default component.exports